import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
const UpdateAppointmentStatus = async (appointmentId) => {
  /**
   * input: appointment Id
   * output: appointment document / collection
   * description: update appointment status / appointment document
   */

  try {
    const AppointmentDocument = await doc(db, "appointments", appointmentId);

    const data = {
      isDone: true,
      ...HelperForMetaData({}),
    };

    return await updateDoc(AppointmentDocument, data)
      .then((res) => true)
      .catch((err) => false);
  } catch (error) {
    console.log(error);
  }
};

export default UpdateAppointmentStatus;
